<template>
    <div id="reportar-duvida">
        <v-row align-items="center" justify="space-evenly" class="header">
            <div
                style="display: flex; flex-direction: column; align-items: start; padding-top: 5%; height: 100%; width: 100%;">
                <v-btn @click="$emit('close-submenu')" variant="text" color="inherit"><img
                        src="https://overmedia-api-staging-sp.s3-sa-east-1.amazonaws.com/654b7f18bf15bb000295a605/642712b9-7c61-4e25-87b0-5b7aefc49d67.svg"
                        alt=""></v-btn>
                <p class="submenu-title">Reportar dúvida ou problema</p>
            </div>
        </v-row>

        <p style="margin-top: 10%; text-align: start; margin-left: 5%;">Descreva abaixo seu problema: </p>

        <v-textarea style="width: 90%; margin-left: 5%; margin-top: 5%;" variant="outlined"
            placeholder="Digite seu problema" v-model="comentario"></v-textarea>

        <v-btn width="90%" color="#660099" @click="SendDuvida">Enviar</v-btn>
    </div>

    <ModalDuvidaReportada @close-modal="openModal = false" v-if="openModal" />
</template>

<script setup>
import { defineEmits, ref } from 'vue';
import { useFelixBagAuxStore } from '../../../../store';
import ModalDuvidaReportada from './ModalDuvidaReportada.vue';

const felixBagAuxStore = useFelixBagAuxStore();
defineEmits(["close-submenu"])

const comentario = ref('')
const openModal = ref(false)

function SendDuvida() {
    felixBagAuxStore.saveEvent(`suporte_comentario`, 'form_submit', comentario.value)
    openModal.value = true
}
</script>

<style scoped>
#reportar-duvida {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    background-color: white;
    z-index: 3;
}

.header {
    height: 25%;
    background-color: #BC4AFF;
    padding-left: 10px;
}

.submenu-title {
    color: white;
    font-size: 20px;
    text-align: start;
    margin-left: 7.5%;
    margin-top: 10%;
}
</style>